import { List, Datagrid, TextField, NumberField, TextInput, useListContext, ReferenceField, DateField, NumberInput, FilterForm, BooleanInput } from 'react-admin';
import { AudioField } from '../components/fields';

const searchFilters = [
  <TextInput label="Query" source="query" alwaysOn />, 
  <NumberInput label="Moderation Rating" source="moderation_rating" min={0} max={5} />,
  <NumberInput label="Limit" source="top_k" min={1} />,
  <TextInput 
    label="Question IDs (comma-separated)" 
    source="question_ids" 
    helperText="Enter up to 20 question IDs separated by commas"
    parse={(value) => value ? value.split(',').map(s => s.trim()) : undefined}
    format={(value) => Array.isArray(value) ? value.join(', ') : value}
  />,
  <TextInput label="Participant ID" source="participant_id" />,
  <TextInput label="Show ID" source="show_id" />,
  <TextInput label="Tags" source="tags" />,
  <BooleanInput label="Show least similar first" source="reverse" />
];
/*
const ResultsLogger = () => {
  const { data } = useListContext();
  console.log('results:', data);
  return null;
};
*/

const CustomEmpty = () => {
  const { filterValues, setFilters, displayedFilters, showFilter } = useListContext();
  return (<div style={{ padding: 20, textAlign: 'left', color: 'grey' }}>
     <FilterForm filters={searchFilters} />
    <p>Enter a query to begin searching the archive.</p>
  </div>
  );
};



const AnswerExpandDetails: React.FC<{ record: any }> = ({ record }) => {
  const answer = record;
 
  return (
    <div style={{ display: 'flex', gap: '20px' }}>
      <div style={{ flex: 4, display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <TextField source="cleaned_transcript" />
      <TextField source="redacted_transcript" />
      <TextField source="tags" />
      </div>
    </div>
  );
};


export const SearchList = () => (
  <List
    resource="nlsearch"
    title="Semantic Search"
    filters={searchFilters}
    filterDefaultValues={{ top_k: 10 }}
    filter={{}}
    empty={<CustomEmpty />}
  >
    {/* <ResultsLogger /> */}
    <Datagrid expand={<AnswerExpandDetails {...({} as any)} />}>
      <TextField source="id" />
      <NumberField source="similarity" />
      <DateField source="created_at" label="Created" showTime />
      <TextField source="question_id" />
      <AudioField source="processed_audio" sortable={false} label="Answer" />
      <TextField source="moderation_rating"  label="Rating" />
    </Datagrid>
  </List>
);